"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    taskHeaderCategory: {
        id: 'task.taskList.taskHeader.Category',
        defaultMessage: 'Category',
        description: 'Tasklist header category',
    },
    taskHeaderTaskName: {
        id: 'task.taskList.taskHeader.Task name',
        defaultMessage: 'Task name.',
        description: 'Tasklist header Task name',
    },
    taskHeaderStatus: {
        id: 'task.taskList.taskHeader.Status',
        defaultMessage: 'Status',
        description: 'Tasklist header Status',
    },
    taskHeaderMachine: {
        id: 'task.taskList.taskHeader.Machine',
        defaultMessage: 'Machine',
        description: 'Tasklist header Machine',
    },
    taskHeaderField: {
        id: 'task.taskList.taskHeader.Field',
        defaultMessage: 'Field',
        description: 'Tasklist header Field',
    },
    taskHeaderCrop: {
        id: 'task.taskList.taskHeader.Crop',
        defaultMessage: 'Crop',
        description: 'Tasklist header Crop',
    },
    taskListCount: {
        id: 'task.taskList.taskCount',
        defaultMessage: 'Showing {visible} of {total} tasks',
        description: 'Tasklist visible of total tasks',
    },
    taskListMyTask: {
        id: 'task.taskList.myTasks',
        defaultMessage: 'My Tasks',
        description: 'Tasklist my Task',
    },
    taskListTbd: {
        id: 'task.taskList.TBD',
        defaultMessage: 'TBD',
        description: 'Tasklist TBD',
    },
    taskListNotifications: {
        id: 'task.taskList.notifications',
        defaultMessage: 'Notifications',
        description: 'Tasklist notifications',
    },
    taskListCreateTask: {
        id: 'task.taskList.createTask',
        defaultMessage: 'Create Task',
        description: 'Tasklist create',
    },
    taskListMyTaskCount: {
        id: 'task.taskList.myTaskCount',
        defaultMessage: '{count, plural, one {# task} other {# tasks}}',
        description: 'Tasklist myTaskcount',
    },
    taskListManageTask: {
        id: 'task.taskList.manageTask',
        defaultMessage: 'Manage Your Task Here',
        description: 'Tasklist manageTask',
    },
    noTasksFound: {
        id: 'task.taskList.noTasksFound',
        defaultMessage: 'No tasks found',
        description: 'No tasks found title',
    },
    noTasksFoundMessage: {
        id: 'task.taskList.noTasksFoundMessage',
        defaultMessage: 'Get started by importing your first task report',
        description: 'No tasks found message',
    },
});
exports.default = messages;
